import ApiService from "@/core/services/api.service";
import {SET_ERROR} from "../auth.module";

const _ = require('lodash');

export const GET_USER_LEVEL_CATEGORY = "user-level-category";
export const CREATE_USER_LEVEL_CATEGORY = "create-user-level-category";
export const UPDATE_USER_LEVEL_CATEGORY = "update-user-level-category";
export const DELETE_USER_LEVEL_CATEGORY = "delete-user-level-category";
//
export const GET_USER_LEVEL = "user-level";
export const GET_USER_LEVEL_ALL = "user-level-all";
export const CREATE_USER_LEVEL = "create-user-level";
export const UPDATE_USER_LEVEL = "update-user-level";
export const DELETE_USER_LEVEL = "delete-user-level";
//
export const GET_TEAMLEAD_CRITERIA_STANDARD = "teamlead-criteria-standard";
export const CREATE_TEAMLEAD_CRITERIA_STANDARD = "create-teamlead-criteria-standard";
export const UPDATE_TEAMLEAD_CRITERIA_STANDARD = "update-teamlead-criteria-standard";
export const DELETE_TEAMLEAD_CRITERIA_STANDARD = "delete-teamlead-criteria-standard";
export const IMPORT_TEAMLEAD_CRITERIA_STANDARD = "teamlead-criteria-standard/import";
export const TEAMLEAD_SCORE_REVIEW = "teamlead-score-review";

const state = {
    errors: null,
    paginateData: [],
};

const getters = {};

const actions = {
    [GET_USER_LEVEL_CATEGORY](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query(GET_USER_LEVEL_CATEGORY, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    [CREATE_USER_LEVEL_CATEGORY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(GET_USER_LEVEL_CATEGORY, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [UPDATE_USER_LEVEL_CATEGORY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${GET_USER_LEVEL_CATEGORY}/` + payload.id, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },

    [DELETE_USER_LEVEL_CATEGORY](context, id) {
        return new Promise(resolve => {
            ApiService.delete(GET_USER_LEVEL_CATEGORY, id).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                console.log(response)
            });
        })
    },

    [GET_USER_LEVEL](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query(GET_USER_LEVEL, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    [GET_USER_LEVEL_ALL](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query(GET_USER_LEVEL_ALL, credentials)
                .then(({data}) => {
                    resolve(data);
                });
        });
    },
    [CREATE_USER_LEVEL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(GET_USER_LEVEL, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [UPDATE_USER_LEVEL](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${GET_USER_LEVEL}/` + payload.id, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },
    [DELETE_USER_LEVEL](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(GET_USER_LEVEL, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    //
    [GET_TEAMLEAD_CRITERIA_STANDARD](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query(GET_TEAMLEAD_CRITERIA_STANDARD, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    [CREATE_TEAMLEAD_CRITERIA_STANDARD](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(GET_TEAMLEAD_CRITERIA_STANDARD, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [UPDATE_TEAMLEAD_CRITERIA_STANDARD](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${GET_TEAMLEAD_CRITERIA_STANDARD}/` + payload.id, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response)
                });
        });
    },

    [DELETE_TEAMLEAD_CRITERIA_STANDARD](context, id) {
        return new Promise(resolve => {
            ApiService.delete(GET_TEAMLEAD_CRITERIA_STANDARD, id).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                console.log(response)
            });
        })
    },
    [IMPORT_TEAMLEAD_CRITERIA_STANDARD](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(IMPORT_TEAMLEAD_CRITERIA_STANDARD, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [TEAMLEAD_SCORE_REVIEW](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query(TEAMLEAD_SCORE_REVIEW, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
